//import {Link, BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { TreeTable } from 'primereact/treetable';
import { saveAs } from 'file-saver';
import dateFormat from '../../services/DateFormat.service';
import React, { useEffect, useRef, useState } from 'react';
import Cookies from 'universal-cookie/es6';
import apis from '../../api';
import '../../DataTableDemo.css';
import { Label } from './CIR.styles';
import Video from '../Video/Video';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import useWindowDimensions from '../hooks/useDimensions';
import './CIR.css'
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { excelReport } from '../../services/excelReport.service';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : RegisterModal
Description : Resto del formulario de registro
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el forumlario desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se agrega documentación al componente 
           después de su implmentación con PrimeReact.
================================================================================ */

export default function CIR(props) {

  /*Propiedas del componente*/
  const [concepto, setConcepto] = useState("");
  const [grupo, setGrupo] = useState("");
  const [reporte, setReporte] = useState("");

  const [listaConceptos, setListaConceptos] = useState([]);
  const [listaGrupos, setListaGrupos] = useState([]);

  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loadPage, setLoadPage] = useState(false)

  /*Propiedades de los modales del componente*/
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);

  /*Constantes glolbales*/
  const headers = {
    authorization: localStorage.getItem('token')
  }

  const cookies = new Cookies();

  /*Propiedades y elementos de la tabla del componente*/
  const [rowData, setRowData] = useState([]);
  const [rows, setRows] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [selectedRows, setSelectedRows] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const elementWidth = { width: "20rem", justifySelf: "center" }

  const toast = useRef(null);
  const { width } = useWindowDimensions()

  useEffect(() => {
    /*Se cargan los datos de las listas de valores requeridad en la pantalla*/
    const getLists = async () => {
      await apis.getCIRConfList(localStorage.getItem('entity'), localStorage.getItem('client'), "1", headers).then(res => {
        let contenido = res.data["GRUPOS_CIR"]
        setListaGrupos(contenido)
      })
      await apis.getCIRConfList(localStorage.getItem('entity'), localStorage.getItem('client'), "2", headers).then(res => {
        let contenido = res.data["CONCEPTS"]
        setListaConceptos(contenido)
      })
      setTabla()
    }
    getLists()
    //console.log(listaConceptos)
  }, [])

  /*Funciones y constantes relacionadas a la tabla del componente*/
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }

  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
          <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (node, column) => {
    /*Valida si la fila de la tabla es fila o subfila con el objetivo de renderizar los botones de acción correspondientes*/
    if (node["key"].length === 1 || node["key"].length === 2) {
      return (
        <div>
          <Button icon="pi pi-plus" className="p-button-success mr-2 p-button-sm text-xs" tooltip="Agregar concepto"
            tooltipOptions={{ position: 'top' }} onClick={() => {
              console.log(node)
              setGrupo(node.data["ID"])
              showModal()
            }}
          />
        </div>
      )
    }
    else {
      if (node["key"].length > 2) {
        return (
          <div>
            <Button icon="pi pi-trash" className="p-button-danger mr-2 p-button-sm text-xs" tooltip="Eliminar concepto"
              tooltipOptions={{ position: 'top' }} onClick={() => {
                setGrupo(node.data["GROUP"]);
                setConcepto(node.data["ID"]);
                showModalEliminar()
              }}
            />
          </div>
        )
      }
    }
  }

  const renderHeader1 = () => {
    return (
      <div className="sb1">
        <div className="sb2">
          <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
          &nbsp;
          &nbsp;
          <Button type="button" label="Reporte de configuración" loading={loading3} onClick={() => { setLoading3(true); postConfReport() }} />
        </div>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave"
            style={{
              width: "100%"
            }}
          />
        </IconField>
      </div>
    )
  }

  const onGlobalFilterChange1 = (e) => {
    /*Función de filtrado global de la tabla*/
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  const clearFilter1 = () => {
    initFilters1();
  }

  const initFilters1 = () => {
    /*Filtros definidos para la tabla del componente*/
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONCEPT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CONCEPT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  const header1 = renderHeader1();

  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  const showModal = () => {
    setIsOpen(true);
    console.log(listaConceptos)
    console.log(listaGrupos)
    console.log(rows)
  };

  /*Constantes que manejan el comportamiento de los modales del componente*/
  const hideModal = () => {
    setIsOpen(false);
    limpiar();
  };

  const showModalEliminar = () => {
    setIsOpenEliminar(true);
  };

  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  async function limpiar() {
    setGrupo("");
    setConcepto("");
  }

  async function setTabla() {
    /*Función que se encarga de cargar los datos que se muestran en la tabla*/
    try {

      await apis.getCIRConf(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
        if (res.data["GROUPS"].length > 0) {
          let data = res.data["GROUPS"]
          let contenidoTabla = []
          data.forEach((element, index) => {
            let datos = element["NAME"].split("|")
            let conceptos = []
            element["CONCEPTS"].forEach((c, i) => {
              conceptos.push({
                key: index.toString() + "." + i.toString(),
                data: {
                  ID: c["CONCEPTS"],
                  NAME: c["NAME"],
                  TYPE: c["TYPE"],
                  GROUP: datos[0]
                }
              })
            })
            contenidoTabla.push({
              key: index.toString(),
              data: {
                ID: datos[0], NAME: datos[1]
              },
              children: conceptos,
            });
          })
          setRows(contenidoTabla)
          setRowData(contenidoTabla)
          setLoadPage(true)
        }
        else {
          setRows([])
          setRowData([])
          setLoadPage(true)
        }
      })
    }
    catch (err) {
      setLoadPage(true)
    }
  }

  async function postCIR() {
    /*Función encarga de almacenar un nuevo concepto de ingresos y retenciones en la base de datos*/
    const _concepto = concepto.CODE;
    const _grupo = grupo;
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity');

    const companyCIR = {
      CLIENT: _cliente,
      ENTITY: _entity,
      IDGROUP: _grupo,
      CONCEPT: _concepto
    }

    try {
      await apis.postCIRConf(companyCIR, headers).then(res => {
        console.log(res.data)
        setLoading1(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Concepto agregado exitosamente' });
      })
      setTabla()
      await apis.getCIRConfList(_entity, _cliente, "2", headers).then(res => {
        let contenido = res.data["CONCEPTS"]
        setListaConceptos(contenido)
      })
      limpiar()
      hideModal()
    }
    catch (err) {
      setLoading1(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }

  }

  async function deleteCIR() {
    /*Función encargada de eliminar un concepto de ingresos y retenciones de la base de datos*/
    const _concepto = concepto;
    const _grupo = grupo;
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity');

    try {
      await apis.deleteCIRConf(_entity, _cliente, _grupo, _concepto, headers).then(res => {
        console.log(res.data)
        setLoading2(false)
        toast.current.show({ severity: 'info', summary: 'Info', detail: 'Concepto eliminado exitosamente' });
      })
      setTabla()
      await apis.getCIRConfList(_entity, _cliente, "2", headers).then(res => {
        let contenido = res.data["CONCEPTS"]
        setListaConceptos(contenido)
      })
      limpiar()
      hideModalEliminar()
    }
    catch (err) {
      setLoading2(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function postConfReport() {
    /*Función encargada de cargar la informacion del reporte de configuración*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity');
    const option = "1"
    const params = [
      {
        PARAMETERS: [
          { LABEL: "pinEntity", VALUE: localStorage.getItem("entity") },
          { LABEL: "pinClient", VALUE: localStorage.getItem("client") }
        ]
      }
    ]
    let report = {
      CLIENT: client,
      ENTITY: _entity,
      OPTION: option,
      REPORTS: params
    }
    try {
      await apis.confReport(report, headers).then(res => {
        finalReport = res.data
        excelReport(finalReport, "reporteConfiguracionIngresos")
        setLoading3(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de configuración generado existosamente" });
      })
    }
    catch (err) {
      console.log(err)
      setLoading3(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  /*Headers y footers de los modales del componente*/
  const addFooter = (
    <div>
      <Button onClick={() => { setLoading1(false); hideModal() }}>Cancelar</Button>
      <Button label="Guardar" loading={loading1} onClick={() => { setLoading1(true); postCIR() }} />
    </div>
  );

  const addHeader = (
    <div>
      <h3>Agregar concepto ingresos y retenciones</h3>
    </div>
  )

  const deleteFooter = (
    <div>
      <Button onClick={() => { setLoading2(false); hideModalEliminar() }}>Cancelar</Button>
      <Button label="Si" loading={loading2} onClick={() => { setLoading2(true); deleteCIR() }} />
    </div>
  );

  const deleteHeader = (
    <div>
      <h3>¿Desea deleteCIR el concepto de ingresos y retenciones?</h3>
    </div>
  )

  const rowClassName = (node) => {
    return { 'p-highlight': (node.data["GROUP"]) };
  }
  /*Renderizado del componente*/
  return (
    <div>
      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
        <Toast ref={toast} />
        <Dialog header={addHeader} footer={addFooter} visible={isOpen}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <Label htmlFor="label">Concepto</Label>
          <Dropdown style={elementWidth} value={concepto}
            options={listaConceptos} placeholder={"Seleccione"}
            filter showClear filterBy="NAME" emptyMessage={"No hay conceptos disponibles"}
            onChange={(e) => {
              setConcepto(e.value)
            }}
            optionLabel="NAME"
          />
        </Dialog>
        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>
        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
          <span className="text-900">Configuración ingresos y retenciones</span>
          <Video header="Instructivo configuración ingresos y retenciones" url={localStorage.getItem('CIR_PAYROLL_VIDEO')} />
        </div>
        <div className='mt-6 flex justify-content-center flex-column align-items-center'>
          <SkeletonTable load={loadPage}>
            <TreeTable className="card text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              responsiveLayout="scroll" selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['ID', 'NAME', 'TYPE']}
              header={header1} rowClassName={rowClassName}>
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="ID" header="Código" expander showFilterOperator={false} filterMatchModeOptions={matchModes} filter={width >= 646 && true} filterPlaceholder="Buscar por código" sortable={width >= 646 && true}></Column>
              <Column field="NAME" header="Concepto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter={width >= 646 && true} filterPlaceholder="Buscar por nombre" sortable={width >= 646 && true}></Column>
              <Column field="TYPE" header="Tipo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter={width >= 646 && true} filterPlaceholder="Buscar por tipo" sortable={width >= 646 && true}></Column>
              <Column header="Acciones" headerStyle={{ width: '8rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </TreeTable>
          </SkeletonTable>
        </div>
      </div>
    </div>
  );
}